import styled from 'styled-components';

export const Container = styled.div`
	border-radius: 5px;
	border: 2px solid #dbd9f7;
	background: #f3f2f9;
	padding: 20px;
	color: #000;
	margin-bottom: 20px;
`;

export const Title = styled.h3`
	font-size: 24px;
	font-weight: 700;
	line-height: normal;
`;

export const Description = styled.p`
	font-size: 16px;
	line-height: 20px;
	margin-top: 10px;
	margin-bottom: 10px;
`;

export const Policy = styled.div`
	display: flex;
	font-size: 16px;
	line-height: 20px;

	p {
		margin-right: 4px;
	}

	a {
		color: rgba(51, 51, 153, 1);
	}

	img {
		width: 88.614px;
		height: 88.614px;
	}
`;
